export enum ProviderType {
  Gps = 'GPS',
  Network = 'NETWORK',
}
